module.exports = __webpack_public_path__ + "static/media/mdm2.573478bf.png";